import React from 'react';
import { RouteComponentProps } from 'react-router';
import RegisterContainerTCS from '../../containers/RegisterContainerTCS/RegisterContainerTCS';

const RegisterPage: React.FC<RouteComponentProps> = props => {
  return <RegisterContainerTCS {...props} />;
};

export default RegisterPage;
